module.exports = __webpack_public_path__ + "media/components/Builder/Library/Images/Tools/Trash-e056b015c7b57b84104f5a8a3d1aba2e.svg";